import "%root/polyfills";
import Vue from "vue";
import "%root/plugins/axios";
import "%root/assets/styles/main.scss";
import App from "%root/App.vue";
import router from "%root/router";
import store from "%root/store";

import dayjs from "dayjs";
import "dayjs/locale/pl";
import VueScrollTo from "vue-scrollto";

import "prismjs";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-solarizedlight.css";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import "./validation";

dayjs.locale("pl");

Vue.use(VueScrollTo);
Vue.prototype.$scrollToTop = () => VueScrollTo.scrollTo("#app", 2000);
Vue.prototype.$immediatelyScrollToTop = () => window.scrollTo(0, 0);

Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
